﻿$(document).on("click", ".uploader .select-file", function (e) {
    e.preventDefault();
    let input = $(this).closest(".uploader").find("input");
    input.click(); // forces the "choose file" dialog to open
});